export * from './component'



// WEBPACK FOOTER //
// ./src/components/loading/index.ts